import { type VenueBasedVenueUserSerializer } from "@shared/modules/venue/types";
import { type VenueBasedCustomerGroupSerializer } from "@app-contexts/dashboard/features/box-office/group-sales/data/types/customer-groups";
import { StateCreator } from "zustand";
import { type Store } from "../useStore";

type State = {
  // TODO create a generic type for customer
  // not everything is defined when creating a new customer
  checkoutCustomer?: Partial<VenueBasedVenueUserSerializer> &
    Partial<VenueBasedCustomerGroupSerializer>;
  isLoadingHoldBasket: boolean;
};

type Actions = {
  clearCheckoutCustomer(): void;
  setCheckoutCustomer(checkoutCustomer: State["checkoutCustomer"]): void;
  setIsLoadingHoldBasket(value: boolean): void;
};

export type CheckoutSlice = State & Actions;

const createCheckoutSlice: StateCreator<
  Store,
  [["zustand/persist", unknown]],
  [],
  CheckoutSlice
> = (set) => ({
  checkoutCustomer: undefined,
  isLoadingHoldBasket: false,

  setCheckoutCustomer(checkoutCustomer) {
    set({ checkoutCustomer });
  },

  clearCheckoutCustomer() {
    set({ checkoutCustomer: undefined });
  },

  setIsLoadingHoldBasket(value) {
    set({ isLoadingHoldBasket: value });
  },
});

export default createCheckoutSlice;
